module.exports = __webpack_public_path__ + "img/shield-dissapproved.f4e915cb.svg";